import * as React from 'react';
import Paper from '@material-ui/core/Paper';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import { useStore } from 'react-redux';
import moment from 'moment';

export default function Parcel_entry() {
  const store: any = useStore();
  const [data7, SetData7]: any = React.useState([]);
  const [data30, SetData30]: any = React.useState([]);
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
  function fetch_table_data() {
    axios
      .get(`${process.env.REACT_APP_API_SERVER}/parcels/create-stats`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      })
      .then((res) => {
        const data = res.data.map((stat: any) => ({
          date: moment(stat.booking_date).format('DDMMM'),
          count: Number(stat.count),
        }));
        SetData30(data.slice(-30));
        SetData7(data.slice(-7));
      });
  }

  React.useEffect(() => {
    fetch_table_data();
    // eslint-disable-next-line
  }, []);

  const BarOption = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Daily Parcel Entry',
      },
    },
  };

  return (
    <div className="bg-white">
      <div className="hidden md:block">
        <Bar
          options={BarOption}
          data={{
            labels: data30.map((d: { date: string }) => d.date),
            datasets: [
              {
                label: 'Parcels Entry',
                data: data30.map((d: { count: string }) => d.count),
                backgroundColor: '#f50057',
              },
            ],
          }}
        />
      </div>
      <div className="md:hidden">
        <Bar
          options={BarOption}
          data={{
            labels: data7.map((d: { date: string }) => d.date),
            datasets: [
              {
                label: 'Parcels Entry',
                data: data7.map((d: { count: string }) => d.count),
                backgroundColor: '#f50057',
              },
            ],
          }}
        />
      </div>
    </div>
  );
}
